import { useState, useEffect, useRef } from 'react'
import { importLibrary, setOptions } from '@googlemaps/js-api-loader'

let configured = false
let loaderPromise: Promise<void> | undefined

function getLoaderPromise(): Promise<void> {
  if (!loaderPromise) {
    if (!configured) {
      const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? ''
      if (!apiKey && import.meta.env.DEV) {
        console.warn('Google Maps API key is not set. Please set the VITE_GOOGLE_MAPS_API_KEY environment variable.')
      }
      setOptions({ key: apiKey })
      configured = true
    }
    loaderPromise = importLibrary('places').then(() => {})
  }
  return loaderPromise
}

export function useGoogleMapsScript() {
  const [isLoaded, setIsLoaded] = useState(false)
  const [loadError, setLoadError] = useState<Error | null>(null)
  const mounted = useRef(false)

  useEffect(() => {
    mounted.current = true
    getLoaderPromise()
      .then(() => {
        if (mounted.current) setIsLoaded(true)
      })
      .catch((err) => {
        if (mounted.current) setLoadError(err instanceof Error ? err : new Error(String(err)))
      })
    return () => {
      mounted.current = false
    }
  }, [])

  return { isLoaded, loadError }
}
